module.exports = __webpack_public_path__ + "img/JST-min.dbfa0dbb.png";